const KabupatenData = [
	{
		"id" : 1,
		"name" : "Aceh Selatan",
		"code" : "1101",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 2,
		"name" : "Aceh Tenggara",
		"code" : "1102",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 3,
		"name" : "Aceh Timur",
		"code" : "1103",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 4,
		"name" : "Aceh Tengah",
		"code" : "1104",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 5,
		"name" : "Aceh Barat",
		"code" : "1105",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 6,
		"name" : "Aceh Besar",
		"code" : "1106",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 7,
		"name" : "Pidie",
		"code" : "1107",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 8,
		"name" : "Aceh Utara",
		"code" : "1108",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 9,
		"name" : "Simeulue",
		"code" : "1109",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 10,
		"name" : "Aceh Singkil",
		"code" : "1110",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 11,
		"name" : "Bireuen",
		"code" : "1111",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 12,
		"name" : "Aceh Barat Daya",
		"code" : "1112",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 13,
		"name" : "Gayo Lues",
		"code" : "1113",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 14,
		"name" : "Aceh Jaya",
		"code" : "1114",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 15,
		"name" : "Nagan Raya",
		"code" : "1115",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 16,
		"name" : "Aceh Tamiang",
		"code" : "1116",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 17,
		"name" : "Bener Meriah",
		"code" : "1117",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 18,
		"name" : "Pidie Jaya",
		"code" : "1118",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 19,
		"name" : "Kota Banda Aceh",
		"code" : "1171",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 20,
		"name" : "Kota Sabang",
		"code" : "1172",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 21,
		"name" : "Kota Lhokseumawe",
		"code" : "1173",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 22,
		"name" : "Kota Langsa",
		"code" : "1174",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 23,
		"name" : "Kota Subulussalam",
		"code" : "1175",
		"regent_mayor" : "",
		"provinsi_id" : "11",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 24,
		"name" : "Tapanuli Tengah",
		"code" : "1201",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 25,
		"name" : "Tapanuli Utara",
		"code" : "1202",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 26,
		"name" : "Tapanuli Selatan",
		"code" : "1203",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 27,
		"name" : "Nias",
		"code" : "1204",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 28,
		"name" : "Langkat",
		"code" : "1205",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 29,
		"name" : "Karo",
		"code" : "1206",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 30,
		"name" : "Deli Serdang",
		"code" : "1207",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 31,
		"name" : "Simalungun",
		"code" : "1208",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 32,
		"name" : "Asahan",
		"code" : "1209",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 33,
		"name" : "Labuhanbatu",
		"code" : "1210",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 34,
		"name" : "Dairi",
		"code" : "1211",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 35,
		"name" : "Toba Samosir",
		"code" : "1212",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 36,
		"name" : "Mandailing Natal",
		"code" : "1213",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 37,
		"name" : "Nias Selatan",
		"code" : "1214",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 38,
		"name" : "Pakpak Bharat",
		"code" : "1215",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 39,
		"name" : "Humbang Hasundutan",
		"code" : "1216",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 40,
		"name" : "Samosir",
		"code" : "1217",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 41,
		"name" : "Serdang Bedagai",
		"code" : "1218",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 42,
		"name" : "Batu Bara",
		"code" : "1219",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 43,
		"name" : "Padang Lawas Utara",
		"code" : "1220",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 44,
		"name" : "Padang Lawas",
		"code" : "1221",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 45,
		"name" : "Labuhanbatu Selatan",
		"code" : "1222",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 46,
		"name" : "Labuhanbatu Utara",
		"code" : "1223",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 47,
		"name" : "Nias Utara",
		"code" : "1224",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 48,
		"name" : "Nias Barat",
		"code" : "1225",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 49,
		"name" : "Kota Medan",
		"code" : "1271",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 50,
		"name" : "Kota Pematang Siantar",
		"code" : "1272",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 51,
		"name" : "Kota Sibolga",
		"code" : "1273",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 52,
		"name" : "Kota Tanjung Balai",
		"code" : "1274",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 53,
		"name" : "Kota Binjai",
		"code" : "1275",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 54,
		"name" : "Kota Tebing Tinggi",
		"code" : "1276",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 55,
		"name" : "Kota Padang Sidimpuan",
		"code" : "1277",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 56,
		"name" : "Kota Gunungsitoli",
		"code" : "1278",
		"regent_mayor" : "",
		"provinsi_id" : "12",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 57,
		"name" : "Pesisir Selatan",
		"code" : "1301",
		"regent_mayor" : "",
		"provinsi_id" : "13",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 58,
		"name" : "Solok",
		"code" : "1302",
		"regent_mayor" : "",
		"provinsi_id" : "13",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 59,
		"name" : "Sijunjung",
		"code" : "1303",
		"regent_mayor" : "",
		"provinsi_id" : "13",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 60,
		"name" : "Tanah Datar",
		"code" : "1304",
		"regent_mayor" : "",
		"provinsi_id" : "13",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 61,
		"name" : "Padang Pariaman",
		"code" : "1305",
		"regent_mayor" : "",
		"provinsi_id" : "13",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 62,
		"name" : "Agam",
		"code" : "1306",
		"regent_mayor" : "",
		"provinsi_id" : "13",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 63,
		"name" : "Lima Puluh Kota",
		"code" : "1307",
		"regent_mayor" : "",
		"provinsi_id" : "13",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 64,
		"name" : "Pasaman",
		"code" : "1308",
		"regent_mayor" : "",
		"provinsi_id" : "13",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 65,
		"name" : "Kepulauan Mentawai",
		"code" : "1309",
		"regent_mayor" : "",
		"provinsi_id" : "13",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 66,
		"name" : "Dharmasraya",
		"code" : "1310",
		"regent_mayor" : "",
		"provinsi_id" : "13",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 67,
		"name" : "Solok Selatan",
		"code" : "1311",
		"regent_mayor" : "",
		"provinsi_id" : "13",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 68,
		"name" : "Pasaman Barat",
		"code" : "1312",
		"regent_mayor" : "",
		"provinsi_id" : "13",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 69,
		"name" : "Kota Padang",
		"code" : "1371",
		"regent_mayor" : "",
		"provinsi_id" : "13",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 70,
		"name" : "Kota Solok",
		"code" : "1372",
		"regent_mayor" : "",
		"provinsi_id" : "13",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 71,
		"name" : "Kota Sawahlunto",
		"code" : "1373",
		"regent_mayor" : "",
		"provinsi_id" : "13",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 72,
		"name" : "Kota Padang Panjang",
		"code" : "1374",
		"regent_mayor" : "",
		"provinsi_id" : "13",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 73,
		"name" : "Kota Bukittinggi",
		"code" : "1375",
		"regent_mayor" : "",
		"provinsi_id" : "13",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 74,
		"name" : "Kota Payakumbuh",
		"code" : "1376",
		"regent_mayor" : "",
		"provinsi_id" : "13",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 75,
		"name" : "Kota Pariaman",
		"code" : "1377",
		"regent_mayor" : "",
		"provinsi_id" : "13",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 76,
		"name" : "Kampar",
		"code" : "1401",
		"regent_mayor" : "",
		"provinsi_id" : "14",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 77,
		"name" : "Indragiri Hulu",
		"code" : "1402",
		"regent_mayor" : "",
		"provinsi_id" : "14",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 78,
		"name" : "Bengkalis",
		"code" : "1403",
		"regent_mayor" : "",
		"provinsi_id" : "14",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 79,
		"name" : "Indragiri Hilir",
		"code" : "1404",
		"regent_mayor" : "",
		"provinsi_id" : "14",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 80,
		"name" : "Pelalawan",
		"code" : "1405",
		"regent_mayor" : "",
		"provinsi_id" : "14",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 81,
		"name" : "Rokan Hulu",
		"code" : "1406",
		"regent_mayor" : "",
		"provinsi_id" : "14",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 82,
		"name" : "Rokan Hilir",
		"code" : "1407",
		"regent_mayor" : "",
		"provinsi_id" : "14",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 83,
		"name" : "Siak",
		"code" : "1408",
		"regent_mayor" : "",
		"provinsi_id" : "14",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 84,
		"name" : "Kuantan Singingi",
		"code" : "1409",
		"regent_mayor" : "",
		"provinsi_id" : "14",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 85,
		"name" : "Kepulauan Meranti",
		"code" : "1410",
		"regent_mayor" : "",
		"provinsi_id" : "14",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 86,
		"name" : "Kota Pekanbaru",
		"code" : "1471",
		"regent_mayor" : "",
		"provinsi_id" : "14",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 87,
		"name" : "Kota Dumai",
		"code" : "1472",
		"regent_mayor" : "",
		"provinsi_id" : "14",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 88,
		"name" : "Kerinci",
		"code" : "1501",
		"regent_mayor" : "",
		"provinsi_id" : "15",
		"is_city" : 0,
		"is_active" : 0,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 89,
		"name" : "Merangin",
		"code" : "1502",
		"regent_mayor" : "",
		"provinsi_id" : "15",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 90,
		"name" : "Sarolangun",
		"code" : "1503",
		"regent_mayor" : "",
		"provinsi_id" : "15",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 91,
		"name" : "Batang Hari",
		"code" : "1504",
		"regent_mayor" : "",
		"provinsi_id" : "15",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 92,
		"name" : "Muaro Jambi",
		"code" : "1505",
		"regent_mayor" : "",
		"provinsi_id" : "15",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 93,
		"name" : "Tanjung Jabung Barat",
		"code" : "1506",
		"regent_mayor" : "",
		"provinsi_id" : "15",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 94,
		"name" : "Tanjung Jabung Timur",
		"code" : "1507",
		"regent_mayor" : "",
		"provinsi_id" : "15",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 95,
		"name" : "Bungo",
		"code" : "1508",
		"regent_mayor" : "",
		"provinsi_id" : "15",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 96,
		"name" : "Tebo",
		"code" : "1509",
		"regent_mayor" : "",
		"provinsi_id" : "15",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 97,
		"name" : "Kota Jambi",
		"code" : "1571",
		"regent_mayor" : "",
		"provinsi_id" : "15",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 98,
		"name" : "Kota Sungai Penuh",
		"code" : "1572",
		"regent_mayor" : "",
		"provinsi_id" : "15",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 99,
		"name" : "Ogan Komering Ulu",
		"code" : "1601",
		"regent_mayor" : "",
		"provinsi_id" : "16",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 100,
		"name" : "Ogan Komering Ilir",
		"code" : "1602",
		"regent_mayor" : "",
		"provinsi_id" : "16",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 101,
		"name" : "Muara Enim",
		"code" : "1603",
		"regent_mayor" : "",
		"provinsi_id" : "16",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 102,
		"name" : "Lahat",
		"code" : "1604",
		"regent_mayor" : "",
		"provinsi_id" : "16",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 103,
		"name" : "Musi Rawas",
		"code" : "1605",
		"regent_mayor" : "",
		"provinsi_id" : "16",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 104,
		"name" : "Musi Banyuasin",
		"code" : "1606",
		"regent_mayor" : "",
		"provinsi_id" : "16",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 105,
		"name" : "Banyuasin",
		"code" : "1607",
		"regent_mayor" : "",
		"provinsi_id" : "16",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 106,
		"name" : "Ogan Komering Ulu Timur",
		"code" : "1608",
		"regent_mayor" : "",
		"provinsi_id" : "16",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 107,
		"name" : "Ogan Komering Ulu Selatan",
		"code" : "1609",
		"regent_mayor" : "",
		"provinsi_id" : "16",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 108,
		"name" : "Ogan Ilir",
		"code" : "1610",
		"regent_mayor" : "",
		"provinsi_id" : "16",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 109,
		"name" : "Empat Lawang",
		"code" : "1611",
		"regent_mayor" : "",
		"provinsi_id" : "16",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 110,
		"name" : "Kota Palembang",
		"code" : "1671",
		"regent_mayor" : "",
		"provinsi_id" : "16",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 111,
		"name" : "Kota Pagar Alam",
		"code" : "1672",
		"regent_mayor" : "",
		"provinsi_id" : "16",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 112,
		"name" : "Kota Lubuk Linggau",
		"code" : "1673",
		"regent_mayor" : "",
		"provinsi_id" : "16",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 113,
		"name" : "Kota Prabumulih",
		"code" : "1674",
		"regent_mayor" : "",
		"provinsi_id" : "16",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 114,
		"name" : "Bengkulu Selatan",
		"code" : "1701",
		"regent_mayor" : "",
		"provinsi_id" : "17",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 115,
		"name" : "Rejang Lebong",
		"code" : "1702",
		"regent_mayor" : "",
		"provinsi_id" : "17",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 116,
		"name" : "Bengkulu Utara",
		"code" : "1703",
		"regent_mayor" : "",
		"provinsi_id" : "17",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 117,
		"name" : "Kaur",
		"code" : "1704",
		"regent_mayor" : "",
		"provinsi_id" : "17",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 118,
		"name" : "Seluma",
		"code" : "1705",
		"regent_mayor" : "",
		"provinsi_id" : "17",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 119,
		"name" : "Muko Muko",
		"code" : "1706",
		"regent_mayor" : "",
		"provinsi_id" : "17",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 120,
		"name" : "Lebong",
		"code" : "1707",
		"regent_mayor" : "",
		"provinsi_id" : "17",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 121,
		"name" : "Kepahiang",
		"code" : "1708",
		"regent_mayor" : "",
		"provinsi_id" : "17",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 122,
		"name" : "Bengkulu Tengah",
		"code" : "1709",
		"regent_mayor" : "",
		"provinsi_id" : "17",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 123,
		"name" : "Kota Bengkulu",
		"code" : "1771",
		"regent_mayor" : "",
		"provinsi_id" : "17",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 124,
		"name" : "Lampung Selatan",
		"code" : "1801",
		"regent_mayor" : "",
		"provinsi_id" : "18",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 125,
		"name" : "Lampung Tengah",
		"code" : "1802",
		"regent_mayor" : "",
		"provinsi_id" : "18",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 126,
		"name" : "Lampung Utara",
		"code" : "1803",
		"regent_mayor" : "",
		"provinsi_id" : "18",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 127,
		"name" : "Lampung Barat",
		"code" : "1804",
		"regent_mayor" : "",
		"provinsi_id" : "18",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 128,
		"name" : "Tulang Bawang",
		"code" : "1805",
		"regent_mayor" : "",
		"provinsi_id" : "18",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 129,
		"name" : "Tanggamus",
		"code" : "1806",
		"regent_mayor" : "",
		"provinsi_id" : "18",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 130,
		"name" : "Lampung Timur",
		"code" : "1807",
		"regent_mayor" : "",
		"provinsi_id" : "18",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 131,
		"name" : "Way Kanan",
		"code" : "1808",
		"regent_mayor" : "",
		"provinsi_id" : "18",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 132,
		"name" : "Pesawaran",
		"code" : "1809",
		"regent_mayor" : "",
		"provinsi_id" : "18",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 133,
		"name" : "Pringsewu",
		"code" : "1810",
		"regent_mayor" : "",
		"provinsi_id" : "18",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 134,
		"name" : "Mesuji",
		"code" : "1811",
		"regent_mayor" : "",
		"provinsi_id" : "18",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 135,
		"name" : "Tulang Bawang Barat",
		"code" : "1812",
		"regent_mayor" : "",
		"provinsi_id" : "18",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 136,
		"name" : "Kota Bandar Lampung",
		"code" : "1871",
		"regent_mayor" : "",
		"provinsi_id" : "18",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 137,
		"name" : "Kota Metro",
		"code" : "1872",
		"regent_mayor" : "",
		"provinsi_id" : "18",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 138,
		"name" : "Bangka",
		"code" : "1901",
		"regent_mayor" : "",
		"provinsi_id" : "19",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 139,
		"name" : "Belitung",
		"code" : "1902",
		"regent_mayor" : "",
		"provinsi_id" : "19",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 140,
		"name" : "Bangka Selatan",
		"code" : "1903",
		"regent_mayor" : "",
		"provinsi_id" : "19",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 141,
		"name" : "Bangka Tengah",
		"code" : "1904",
		"regent_mayor" : "",
		"provinsi_id" : "19",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 142,
		"name" : "Bangka Barat",
		"code" : "1905",
		"regent_mayor" : "",
		"provinsi_id" : "19",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 143,
		"name" : "Belitung Timur",
		"code" : "1906",
		"regent_mayor" : "",
		"provinsi_id" : "19",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 144,
		"name" : "Kota Pangkal Pinang",
		"code" : "1971",
		"regent_mayor" : "",
		"provinsi_id" : "19",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 145,
		"name" : "Bintan",
		"code" : "2101",
		"regent_mayor" : "",
		"provinsi_id" : "21",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 146,
		"name" : "Karimun",
		"code" : "2102",
		"regent_mayor" : "",
		"provinsi_id" : "21",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 147,
		"name" : "Natuna",
		"code" : "2103",
		"regent_mayor" : "",
		"provinsi_id" : "21",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 148,
		"name" : "Lingga",
		"code" : "2104",
		"regent_mayor" : "",
		"provinsi_id" : "21",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 149,
		"name" : "Kepulauan Anambas",
		"code" : "2105",
		"regent_mayor" : "",
		"provinsi_id" : "21",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 150,
		"name" : "Kota Batam",
		"code" : "2171",
		"regent_mayor" : "",
		"provinsi_id" : "21",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 151,
		"name" : "Kota Tanjung Pinang",
		"code" : "2172",
		"regent_mayor" : "",
		"provinsi_id" : "21",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 152,
		"name" : "Kepulauan Seribu",
		"code" : "3101",
		"regent_mayor" : "",
		"provinsi_id" : "31",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 153,
		"name" : "Jakarta Pusat",
		"code" : "3171",
		"regent_mayor" : "",
		"provinsi_id" : "31",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 154,
		"name" : "Jakarta Utara",
		"code" : "3172",
		"regent_mayor" : "",
		"provinsi_id" : "31",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 155,
		"name" : "Jakarta Barat",
		"code" : "3173",
		"regent_mayor" : "",
		"provinsi_id" : "31",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 156,
		"name" : "Jakarta Selatan",
		"code" : "3174",
		"regent_mayor" : "",
		"provinsi_id" : "31",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 157,
		"name" : "Jakarta Timur",
		"code" : "3175",
		"regent_mayor" : "",
		"provinsi_id" : "31",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 158,
		"name" : "Bogor",
		"code" : "3201",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 159,
		"name" : "Sukabumi",
		"code" : "3202",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 160,
		"name" : "Cianjur",
		"code" : "3203",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 161,
		"name" : "Bandung",
		"code" : "3204",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 162,
		"name" : "Garut",
		"code" : "3205",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 163,
		"name" : "Tasikmalaya",
		"code" : "3206",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 164,
		"name" : "Ciamis",
		"code" : "3207",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 165,
		"name" : "Kuningan",
		"code" : "3208",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 166,
		"name" : "Cirebon",
		"code" : "3209",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 167,
		"name" : "Majalengka",
		"code" : "3210",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 168,
		"name" : "Sumedang",
		"code" : "3211",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 169,
		"name" : "Indramayu",
		"code" : "3212",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 170,
		"name" : "Subang",
		"code" : "3213",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 171,
		"name" : "Purwakarta",
		"code" : "3214",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 172,
		"name" : "Karawang",
		"code" : "3215",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 173,
		"name" : "Bekasi",
		"code" : "3216",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 174,
		"name" : "Bandung Barat",
		"code" : "3217",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 175,
		"name" : "Kota Bogor",
		"code" : "3271",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 176,
		"name" : "Kota Sukabumi",
		"code" : "3272",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 177,
		"name" : "Kota Bandung",
		"code" : "3273",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 178,
		"name" : "Kota Cirebon",
		"code" : "3274",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 179,
		"name" : "Kota Bekasi",
		"code" : "3275",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 180,
		"name" : "Kota Depok",
		"code" : "3276",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 181,
		"name" : "Kota Cimahi",
		"code" : "3277",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 182,
		"name" : "Kota Tasikmalaya",
		"code" : "3278",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 183,
		"name" : "Kota Banjar",
		"code" : "3279",
		"regent_mayor" : "",
		"provinsi_id" : "32",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 184,
		"name" : "Cilacap",
		"code" : "3301",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 185,
		"name" : "Banyumas",
		"code" : "3302",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 186,
		"name" : "Purbalingga",
		"code" : "3303",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 187,
		"name" : "Banjarnegara",
		"code" : "3304",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 188,
		"name" : "Kebumen",
		"code" : "3305",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 189,
		"name" : "Purworejo",
		"code" : "3306",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 190,
		"name" : "Wonosobo",
		"code" : "3307",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 191,
		"name" : "Magelang",
		"code" : "3308",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 192,
		"name" : "Boyolali",
		"code" : "3309",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 193,
		"name" : "Klaten",
		"code" : "3310",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 194,
		"name" : "Sukoharjo",
		"code" : "3311",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 195,
		"name" : "Wonogiri",
		"code" : "3312",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 196,
		"name" : "Karanganyar",
		"code" : "3313",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 197,
		"name" : "Sragen",
		"code" : "3314",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 198,
		"name" : "Grobogan",
		"code" : "3315",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 199,
		"name" : "Blora",
		"code" : "3316",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 200,
		"name" : "Rembang",
		"code" : "3317",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 201,
		"name" : "Pati",
		"code" : "3318",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 202,
		"name" : "Kudus",
		"code" : "3319",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 203,
		"name" : "Jepara",
		"code" : "3320",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 204,
		"name" : "Demak",
		"code" : "3321",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 205,
		"name" : "Semarang",
		"code" : "3322",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 206,
		"name" : "Temanggung",
		"code" : "3323",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 207,
		"name" : "Kendal",
		"code" : "3324",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 208,
		"name" : "Batang",
		"code" : "3325",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 209,
		"name" : "Pekalongan",
		"code" : "3326",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 210,
		"name" : "Pemalang",
		"code" : "3327",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 211,
		"name" : "Tegal",
		"code" : "3328",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 212,
		"name" : "Brebes",
		"code" : "3329",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 213,
		"name" : "Kota Magelang",
		"code" : "3371",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 214,
		"name" : "Kota Surakarta",
		"code" : "3372",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 215,
		"name" : "Kota Salatiga",
		"code" : "3373",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 216,
		"name" : "Kota Semarang",
		"code" : "3374",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 217,
		"name" : "Kota Pekalongan",
		"code" : "3375",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 218,
		"name" : "Kota Tegal",
		"code" : "3376",
		"regent_mayor" : "",
		"provinsi_id" : "33",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 219,
		"name" : "Kulonprogo",
		"code" : "3401",
		"regent_mayor" : "",
		"provinsi_id" : "34",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 220,
		"name" : "Bantul",
		"code" : "3402",
		"regent_mayor" : "",
		"provinsi_id" : "34",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 221,
		"name" : "Gunung Kidul",
		"code" : "3403",
		"regent_mayor" : "",
		"provinsi_id" : "34",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 222,
		"name" : "Sleman",
		"code" : "3404",
		"regent_mayor" : "",
		"provinsi_id" : "34",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 223,
		"name" : "Kota Yogyakarta",
		"code" : "3471",
		"regent_mayor" : "",
		"provinsi_id" : "34",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 224,
		"name" : "Pacitan",
		"code" : "3501",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 225,
		"name" : "Ponorogo",
		"code" : "3502",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 226,
		"name" : "Trenggalek",
		"code" : "3503",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 227,
		"name" : "Tulungagung",
		"code" : "3504",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 228,
		"name" : "Blitar",
		"code" : "3505",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 229,
		"name" : "Kediri",
		"code" : "3506",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 230,
		"name" : "Malang",
		"code" : "3507",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 231,
		"name" : "Lumajang",
		"code" : "3508",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 232,
		"name" : "Jember",
		"code" : "3509",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 233,
		"name" : "Banyuwangi",
		"code" : "3510",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 234,
		"name" : "Bondowoso",
		"code" : "3511",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 235,
		"name" : "Situbondo",
		"code" : "3512",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 236,
		"name" : "Probolinggo",
		"code" : "3513",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 237,
		"name" : "Pasuruan",
		"code" : "3514",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 238,
		"name" : "Sidoarjo",
		"code" : "3515",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 239,
		"name" : "Mojokerto",
		"code" : "3516",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 240,
		"name" : "Jombang",
		"code" : "3517",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 241,
		"name" : "Nganjuk",
		"code" : "3518",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 242,
		"name" : "Madiun",
		"code" : "3519",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 243,
		"name" : "Magetan",
		"code" : "3520",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 244,
		"name" : "Ngawi",
		"code" : "3521",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 245,
		"name" : "Bojonegoro",
		"code" : "3522",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 246,
		"name" : "Tuban",
		"code" : "3523",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 247,
		"name" : "Lamongan",
		"code" : "3524",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 248,
		"name" : "Gresik",
		"code" : "3525",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 249,
		"name" : "Bangkalan",
		"code" : "3526",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 250,
		"name" : "Sampang",
		"code" : "3527",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 251,
		"name" : "Pamekasan",
		"code" : "3528",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 252,
		"name" : "Sumenep",
		"code" : "3529",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 253,
		"name" : "Kota Kediri",
		"code" : "3571",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 254,
		"name" : "Kota Blitar",
		"code" : "3572",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 255,
		"name" : "Kota Malang",
		"code" : "3573",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 256,
		"name" : "Kota Probolinggo",
		"code" : "3574",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 257,
		"name" : "Kota Pasuruan",
		"code" : "3575",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 258,
		"name" : "Kota Mojokerto",
		"code" : "3576",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 259,
		"name" : "Kota Madiun",
		"code" : "3577",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 260,
		"name" : "Kota Surabaya",
		"code" : "3578",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 261,
		"name" : "Kota Batu",
		"code" : "3579",
		"regent_mayor" : "",
		"provinsi_id" : "35",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 262,
		"name" : "Pandeglang",
		"code" : "3601",
		"regent_mayor" : "",
		"provinsi_id" : "36",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 263,
		"name" : "Lebak",
		"code" : "3602",
		"regent_mayor" : "",
		"provinsi_id" : "36",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 264,
		"name" : "Tangerang",
		"code" : "3603",
		"regent_mayor" : "",
		"provinsi_id" : "36",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 265,
		"name" : "Serang",
		"code" : "3604",
		"regent_mayor" : "",
		"provinsi_id" : "36",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 266,
		"name" : "Kota Tangerang",
		"code" : "3671",
		"regent_mayor" : "",
		"provinsi_id" : "36",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 267,
		"name" : "Kota Cilegon",
		"code" : "3672",
		"regent_mayor" : "",
		"provinsi_id" : "36",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 268,
		"name" : "Kota Serang",
		"code" : "3673",
		"regent_mayor" : "",
		"provinsi_id" : "36",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 269,
		"name" : "Kota Tangerang Selatan",
		"code" : "3674",
		"regent_mayor" : "",
		"provinsi_id" : "36",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 270,
		"name" : "Jembrana",
		"code" : "5101",
		"regent_mayor" : "",
		"provinsi_id" : "51",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 271,
		"name" : "Tabanan",
		"code" : "5102",
		"regent_mayor" : "",
		"provinsi_id" : "51",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 272,
		"name" : "Badung",
		"code" : "5103",
		"regent_mayor" : "",
		"provinsi_id" : "51",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 273,
		"name" : "Gianyar",
		"code" : "5104",
		"regent_mayor" : "",
		"provinsi_id" : "51",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 274,
		"name" : "Klungkung",
		"code" : "5105",
		"regent_mayor" : "",
		"provinsi_id" : "51",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 275,
		"name" : "Bangli",
		"code" : "5106",
		"regent_mayor" : "",
		"provinsi_id" : "51",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 276,
		"name" : "Karang Asem",
		"code" : "5107",
		"regent_mayor" : "",
		"provinsi_id" : "51",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 277,
		"name" : "Buleleng",
		"code" : "5108",
		"regent_mayor" : "",
		"provinsi_id" : "51",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 278,
		"name" : "Kota Denpasar",
		"code" : "5171",
		"regent_mayor" : "",
		"provinsi_id" : "51",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 279,
		"name" : "Lombok Barat",
		"code" : "5201",
		"regent_mayor" : "",
		"provinsi_id" : "52",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 280,
		"name" : "Lombok Tengah",
		"code" : "5202",
		"regent_mayor" : "",
		"provinsi_id" : "52",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 281,
		"name" : "Lombok Timur",
		"code" : "5203",
		"regent_mayor" : "",
		"provinsi_id" : "52",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 282,
		"name" : "Sumbawa",
		"code" : "5204",
		"regent_mayor" : "",
		"provinsi_id" : "52",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 283,
		"name" : "Dompu",
		"code" : "5205",
		"regent_mayor" : "",
		"provinsi_id" : "52",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 284,
		"name" : "Bima",
		"code" : "5206",
		"regent_mayor" : "",
		"provinsi_id" : "52",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 285,
		"name" : "Sumbawa Barat",
		"code" : "5207",
		"regent_mayor" : "",
		"provinsi_id" : "52",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 286,
		"name" : "Lombok Utara",
		"code" : "5208",
		"regent_mayor" : "",
		"provinsi_id" : "52",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 287,
		"name" : "Kota Mataram",
		"code" : "5271",
		"regent_mayor" : "",
		"provinsi_id" : "52",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 288,
		"name" : "Kota Bima",
		"code" : "5272",
		"regent_mayor" : "",
		"provinsi_id" : "52",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 289,
		"name" : "Kupang",
		"code" : "5301",
		"regent_mayor" : "",
		"provinsi_id" : "53",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 290,
		"name" : "Timor Tengah Selatan",
		"code" : "5302",
		"regent_mayor" : "",
		"provinsi_id" : "53",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 291,
		"name" : "Timor Tengah Utara",
		"code" : "5303",
		"regent_mayor" : "",
		"provinsi_id" : "53",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 292,
		"name" : "Belu",
		"code" : "5304",
		"regent_mayor" : "",
		"provinsi_id" : "53",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 293,
		"name" : "Alor",
		"code" : "5305",
		"regent_mayor" : "",
		"provinsi_id" : "53",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 294,
		"name" : "Flores Timur",
		"code" : "5306",
		"regent_mayor" : "",
		"provinsi_id" : "53",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 295,
		"name" : "Sikka",
		"code" : "5307",
		"regent_mayor" : "",
		"provinsi_id" : "53",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 296,
		"name" : "Ende",
		"code" : "5308",
		"regent_mayor" : "",
		"provinsi_id" : "53",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 297,
		"name" : "Ngada",
		"code" : "5309",
		"regent_mayor" : "",
		"provinsi_id" : "53",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 298,
		"name" : "Manggarai",
		"code" : "5310",
		"regent_mayor" : "",
		"provinsi_id" : "53",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 299,
		"name" : "Sumba Timur",
		"code" : "5311",
		"regent_mayor" : "",
		"provinsi_id" : "53",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 300,
		"name" : "Sumba Barat",
		"code" : "5312",
		"regent_mayor" : "",
		"provinsi_id" : "53",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 301,
		"name" : "Lembata",
		"code" : "5313",
		"regent_mayor" : "",
		"provinsi_id" : "53",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 302,
		"name" : "Rotendao",
		"code" : "5314",
		"regent_mayor" : "",
		"provinsi_id" : "53",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 303,
		"name" : "Manggarai Barat",
		"code" : "5315",
		"regent_mayor" : "",
		"provinsi_id" : "53",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 304,
		"name" : "Nagekeo",
		"code" : "5316",
		"regent_mayor" : "",
		"provinsi_id" : "53",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 305,
		"name" : "Sumba Tengah",
		"code" : "5317",
		"regent_mayor" : "",
		"provinsi_id" : "53",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 306,
		"name" : "Sumba Barat Daya",
		"code" : "5318",
		"regent_mayor" : "",
		"provinsi_id" : "53",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 307,
		"name" : "Manggarai Timur",
		"code" : "5319",
		"regent_mayor" : "",
		"provinsi_id" : "53",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 308,
		"name" : "Sabu Raijua",
		"code" : "5320",
		"regent_mayor" : "",
		"provinsi_id" : "53",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 309,
		"name" : "Kota Kupang",
		"code" : "5371",
		"regent_mayor" : "",
		"provinsi_id" : "53",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 310,
		"name" : "Sambas",
		"code" : "6101",
		"regent_mayor" : "",
		"provinsi_id" : "61",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 311,
		"name" : "Pontianak",
		"code" : "6102",
		"regent_mayor" : "",
		"provinsi_id" : "61",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 312,
		"name" : "Sanggau",
		"code" : "6103",
		"regent_mayor" : "",
		"provinsi_id" : "61",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 313,
		"name" : "Ketapang",
		"code" : "6104",
		"regent_mayor" : "",
		"provinsi_id" : "61",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 314,
		"name" : "Sintang",
		"code" : "6105",
		"regent_mayor" : "",
		"provinsi_id" : "61",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 315,
		"name" : "Kapuas Hulu",
		"code" : "6106",
		"regent_mayor" : "",
		"provinsi_id" : "61",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 316,
		"name" : "Bengkayang",
		"code" : "6107",
		"regent_mayor" : "",
		"provinsi_id" : "61",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 317,
		"name" : "Landak",
		"code" : "6108",
		"regent_mayor" : "",
		"provinsi_id" : "61",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 318,
		"name" : "Sekadau",
		"code" : "6109",
		"regent_mayor" : "",
		"provinsi_id" : "61",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 319,
		"name" : "Melawi",
		"code" : "6110",
		"regent_mayor" : "",
		"provinsi_id" : "61",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 320,
		"name" : "Kayong Utara",
		"code" : "6111",
		"regent_mayor" : "",
		"provinsi_id" : "61",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 321,
		"name" : "Kubu Raya",
		"code" : "6112",
		"regent_mayor" : "",
		"provinsi_id" : "61",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 322,
		"name" : "Kota Pontianak",
		"code" : "6171",
		"regent_mayor" : "",
		"provinsi_id" : "61",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 323,
		"name" : "Kota Singkawang",
		"code" : "6172",
		"regent_mayor" : "",
		"provinsi_id" : "61",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 324,
		"name" : "Kotawaringin Barat",
		"code" : "6201",
		"regent_mayor" : "",
		"provinsi_id" : "62",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 325,
		"name" : "Kotawaringin Timur",
		"code" : "6202",
		"regent_mayor" : "",
		"provinsi_id" : "62",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 326,
		"name" : "Kapuas",
		"code" : "6203",
		"regent_mayor" : "",
		"provinsi_id" : "62",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 327,
		"name" : "Barito Selatan",
		"code" : "6204",
		"regent_mayor" : "",
		"provinsi_id" : "62",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 328,
		"name" : "Barito Utara",
		"code" : "6205",
		"regent_mayor" : "",
		"provinsi_id" : "62",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 329,
		"name" : "Katingan",
		"code" : "6206",
		"regent_mayor" : "",
		"provinsi_id" : "62",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 330,
		"name" : "Seruyan",
		"code" : "6207",
		"regent_mayor" : "",
		"provinsi_id" : "62",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 331,
		"name" : "Sukamara",
		"code" : "6208",
		"regent_mayor" : "",
		"provinsi_id" : "62",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 332,
		"name" : "Lamandau",
		"code" : "6209",
		"regent_mayor" : "",
		"provinsi_id" : "62",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 333,
		"name" : "Gunung Mas",
		"code" : "6210",
		"regent_mayor" : "",
		"provinsi_id" : "62",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 334,
		"name" : "Pulang Pisau",
		"code" : "6211",
		"regent_mayor" : "",
		"provinsi_id" : "62",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 335,
		"name" : "Murung Raya",
		"code" : "6212",
		"regent_mayor" : "",
		"provinsi_id" : "62",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 336,
		"name" : "Barito Timur",
		"code" : "6213",
		"regent_mayor" : "",
		"provinsi_id" : "62",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 337,
		"name" : "Lamandau",
		"code" : "6214",
		"regent_mayor" : "",
		"provinsi_id" : "62",
		"is_city" : 0,
		"is_active" : 0,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 338,
		"name" : "Kota Palangkaraya",
		"code" : "6271",
		"regent_mayor" : "",
		"provinsi_id" : "62",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 339,
		"name" : "Tanah Laut",
		"code" : "6301",
		"regent_mayor" : "",
		"provinsi_id" : "63",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 340,
		"name" : "Baru",
		"code" : "6302",
		"regent_mayor" : "",
		"provinsi_id" : "63",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 341,
		"name" : "Banjar",
		"code" : "6303",
		"regent_mayor" : "",
		"provinsi_id" : "63",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 342,
		"name" : "Barito Kuala",
		"code" : "6304",
		"regent_mayor" : "",
		"provinsi_id" : "63",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 343,
		"name" : "Tapin",
		"code" : "6305",
		"regent_mayor" : "",
		"provinsi_id" : "63",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 344,
		"name" : "Hulu Sungai Selatan",
		"code" : "6306",
		"regent_mayor" : "",
		"provinsi_id" : "63",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 345,
		"name" : "Hulu Sungai Tengah",
		"code" : "6307",
		"regent_mayor" : "",
		"provinsi_id" : "63",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 346,
		"name" : "Hulu Sungai Utara",
		"code" : "6308",
		"regent_mayor" : "",
		"provinsi_id" : "63",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 347,
		"name" : "Tabalong",
		"code" : "6309",
		"regent_mayor" : "",
		"provinsi_id" : "63",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 348,
		"name" : "Tanah Bumbu",
		"code" : "6310",
		"regent_mayor" : "",
		"provinsi_id" : "63",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 349,
		"name" : "Balangan",
		"code" : "6311",
		"regent_mayor" : "",
		"provinsi_id" : "63",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 350,
		"name" : "Kota Banjarmasin",
		"code" : "6371",
		"regent_mayor" : "",
		"provinsi_id" : "63",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 351,
		"name" : "Kota Banjarbaru",
		"code" : "6372",
		"regent_mayor" : "",
		"provinsi_id" : "63",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 352,
		"name" : "Paser",
		"code" : "6401",
		"regent_mayor" : "",
		"provinsi_id" : "64",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 353,
		"name" : "Kutai Kertanegara",
		"code" : "6402",
		"regent_mayor" : "",
		"provinsi_id" : "64",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 354,
		"name" : "Berau",
		"code" : "6403",
		"regent_mayor" : "",
		"provinsi_id" : "64",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 355,
		"name" : "Kutai Barat",
		"code" : "6407",
		"regent_mayor" : "",
		"provinsi_id" : "64",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 356,
		"name" : "Kutai Timur",
		"code" : "6408",
		"regent_mayor" : "",
		"provinsi_id" : "64",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 357,
		"name" : "Penajam Paser Utara",
		"code" : "6409",
		"regent_mayor" : "",
		"provinsi_id" : "64",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 358,
		"name" : "Kota Balikpapan",
		"code" : "6471",
		"regent_mayor" : "",
		"provinsi_id" : "64",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 359,
		"name" : "Kota Samarinda",
		"code" : "6472",
		"regent_mayor" : "",
		"provinsi_id" : "64",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 360,
		"name" : "Kota Bontang",
		"code" : "6474",
		"regent_mayor" : "",
		"provinsi_id" : "64",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 361,
		"name" : "Bulungan",
		"code" : "6501",
		"regent_mayor" : "",
		"provinsi_id" : "65",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 362,
		"name" : "Malinau",
		"code" : "6502",
		"regent_mayor" : "",
		"provinsi_id" : "65",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 363,
		"name" : "Nunukan",
		"code" : "6503",
		"regent_mayor" : "",
		"provinsi_id" : "65",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 364,
		"name" : "Tana Tidung",
		"code" : "6504",
		"regent_mayor" : "",
		"provinsi_id" : "65",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 365,
		"name" : "Kota Tarakan",
		"code" : "6571",
		"regent_mayor" : "",
		"provinsi_id" : "65",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 366,
		"name" : "Bolaang Mongondow",
		"code" : "7101",
		"regent_mayor" : "",
		"provinsi_id" : "71",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 367,
		"name" : "Minahasa",
		"code" : "7102",
		"regent_mayor" : "",
		"provinsi_id" : "71",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 368,
		"name" : "Kepulauan Sangihe",
		"code" : "7103",
		"regent_mayor" : "",
		"provinsi_id" : "71",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 369,
		"name" : "Kepulauan Talaud",
		"code" : "7104",
		"regent_mayor" : "",
		"provinsi_id" : "71",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 370,
		"name" : "Minahasa Selatan",
		"code" : "7105",
		"regent_mayor" : "",
		"provinsi_id" : "71",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 371,
		"name" : "Minahasa Utara",
		"code" : "7106",
		"regent_mayor" : "",
		"provinsi_id" : "71",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 372,
		"name" : "Minahasa Tenggara",
		"code" : "7107",
		"regent_mayor" : "",
		"provinsi_id" : "71",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 373,
		"name" : "Bolaang Mongondow Utara",
		"code" : "7108",
		"regent_mayor" : "",
		"provinsi_id" : "71",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 374,
		"name" : "Kep. Siau Tagulandang Biaro",
		"code" : "7109",
		"regent_mayor" : "",
		"provinsi_id" : "71",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 375,
		"name" : "Bolaang Mongondow Timur",
		"code" : "7110",
		"regent_mayor" : "",
		"provinsi_id" : "71",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 376,
		"name" : "Bolaang Mongondow Selatan",
		"code" : "7111",
		"regent_mayor" : "",
		"provinsi_id" : "71",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 377,
		"name" : "Kota Manado",
		"code" : "7171",
		"regent_mayor" : "",
		"provinsi_id" : "71",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 378,
		"name" : "Kota Bitung",
		"code" : "7172",
		"regent_mayor" : "",
		"provinsi_id" : "71",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 379,
		"name" : "Kota Tomohon",
		"code" : "7173",
		"regent_mayor" : "",
		"provinsi_id" : "71",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 380,
		"name" : "Kota Kotamobago",
		"code" : "7174",
		"regent_mayor" : "",
		"provinsi_id" : "71",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 381,
		"name" : "Banggai",
		"code" : "7201",
		"regent_mayor" : "",
		"provinsi_id" : "72",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 382,
		"name" : "Poso",
		"code" : "7202",
		"regent_mayor" : "",
		"provinsi_id" : "72",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 383,
		"name" : "Donggala",
		"code" : "7203",
		"regent_mayor" : "",
		"provinsi_id" : "72",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 384,
		"name" : "Toli Toli",
		"code" : "7204",
		"regent_mayor" : "",
		"provinsi_id" : "72",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 385,
		"name" : "Buol",
		"code" : "7205",
		"regent_mayor" : "",
		"provinsi_id" : "72",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 386,
		"name" : "Morowali",
		"code" : "7206",
		"regent_mayor" : "",
		"provinsi_id" : "72",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 387,
		"name" : "Banggai Kepulauan",
		"code" : "7207",
		"regent_mayor" : "",
		"provinsi_id" : "72",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 388,
		"name" : "Parigi Moutong",
		"code" : "7208",
		"regent_mayor" : "",
		"provinsi_id" : "72",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 389,
		"name" : "Tojo Una Una",
		"code" : "7209",
		"regent_mayor" : "",
		"provinsi_id" : "72",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 390,
		"name" : "Sigi",
		"code" : "7210",
		"regent_mayor" : "",
		"provinsi_id" : "72",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 391,
		"name" : "Kota Palu",
		"code" : "7271",
		"regent_mayor" : "",
		"provinsi_id" : "72",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 392,
		"name" : "Kepulauan Selayar",
		"code" : "7301",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 393,
		"name" : "Bulukumba",
		"code" : "7302",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 394,
		"name" : "Bantaeng",
		"code" : "7303",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 395,
		"name" : "Jeneponto",
		"code" : "7304",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 396,
		"name" : "Takalar",
		"code" : "7305",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 397,
		"name" : "Gowa",
		"code" : "7306",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 398,
		"name" : "Sinjai",
		"code" : "7307",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 399,
		"name" : "Bone",
		"code" : "7308",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 400,
		"name" : "Maros",
		"code" : "7309",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 401,
		"name" : "Pangkajene Kepulauan",
		"code" : "7310",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 402,
		"name" : "Barru",
		"code" : "7311",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 403,
		"name" : "Soppeng",
		"code" : "7312",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 404,
		"name" : "Wajo",
		"code" : "7313",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 405,
		"name" : "Sidenreng Rapang",
		"code" : "7314",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 406,
		"name" : "Pinrang",
		"code" : "7315",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 407,
		"name" : "Enrekang",
		"code" : "7316",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 408,
		"name" : "Luwu",
		"code" : "7317",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 409,
		"name" : "Tana Toraja",
		"code" : "7318",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 410,
		"name" : "Polmas",
		"code" : "7319",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 411,
		"name" : "Luwu Utara",
		"code" : "7322",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 412,
		"name" : "Luwu Timur",
		"code" : "7324",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 413,
		"name" : "Toraja Utara",
		"code" : "7326",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 414,
		"name" : "Kota Makassar",
		"code" : "7371",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 415,
		"name" : "Kota Pare Pare",
		"code" : "7372",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 416,
		"name" : "Kota Palopo",
		"code" : "7373",
		"regent_mayor" : "",
		"provinsi_id" : "73",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 417,
		"name" : "Kolaka",
		"code" : "7401",
		"regent_mayor" : "",
		"provinsi_id" : "74",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 418,
		"name" : "Kendari",
		"code" : "7402",
		"regent_mayor" : "",
		"provinsi_id" : "74",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 419,
		"name" : "Muna",
		"code" : "7403",
		"regent_mayor" : "",
		"provinsi_id" : "74",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 420,
		"name" : "Buton",
		"code" : "7404",
		"regent_mayor" : "",
		"provinsi_id" : "74",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 421,
		"name" : "Konawe Selatan",
		"code" : "7405",
		"regent_mayor" : "",
		"provinsi_id" : "74",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 422,
		"name" : "Bombana",
		"code" : "7406",
		"regent_mayor" : "",
		"provinsi_id" : "74",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 423,
		"name" : "Wakatobi",
		"code" : "7407",
		"regent_mayor" : "",
		"provinsi_id" : "74",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 424,
		"name" : "Kolaka Utara",
		"code" : "7408",
		"regent_mayor" : "",
		"provinsi_id" : "74",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 425,
		"name" : "Konawe Utara",
		"code" : "7409",
		"regent_mayor" : "",
		"provinsi_id" : "74",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 426,
		"name" : "Buton Utara",
		"code" : "7410",
		"regent_mayor" : "",
		"provinsi_id" : "74",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 427,
		"name" : "Kota Kendari",
		"code" : "7471",
		"regent_mayor" : "",
		"provinsi_id" : "74",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 428,
		"name" : "Kota Bau Bau",
		"code" : "7472",
		"regent_mayor" : "",
		"provinsi_id" : "74",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 429,
		"name" : "Gorontalo",
		"code" : "7501",
		"regent_mayor" : "",
		"provinsi_id" : "75",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 430,
		"name" : "Boalemo",
		"code" : "7502",
		"regent_mayor" : "",
		"provinsi_id" : "75",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 431,
		"name" : "Bone Bolango",
		"code" : "7503",
		"regent_mayor" : "",
		"provinsi_id" : "75",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 432,
		"name" : "Pahuwato",
		"code" : "7504",
		"regent_mayor" : "",
		"provinsi_id" : "75",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 433,
		"name" : "Gorontalo Utara",
		"code" : "7505",
		"regent_mayor" : "",
		"provinsi_id" : "75",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 434,
		"name" : "Kota Gorontalo",
		"code" : "7571",
		"regent_mayor" : "",
		"provinsi_id" : "75",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 435,
		"name" : "Mamuju Utara",
		"code" : "7601",
		"regent_mayor" : "",
		"provinsi_id" : "76",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 436,
		"name" : "Mamuju",
		"code" : "7602",
		"regent_mayor" : "",
		"provinsi_id" : "76",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 437,
		"name" : "Mamasa",
		"code" : "7603",
		"regent_mayor" : "",
		"provinsi_id" : "76",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 438,
		"name" : "Polewali Mandar",
		"code" : "7604",
		"regent_mayor" : "",
		"provinsi_id" : "76",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 439,
		"name" : "Majene",
		"code" : "7605",
		"regent_mayor" : "",
		"provinsi_id" : "76",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 440,
		"name" : "Maluku Tengah",
		"code" : "8101",
		"regent_mayor" : "",
		"provinsi_id" : "81",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 441,
		"name" : "Maluku Tenggara",
		"code" : "8102",
		"regent_mayor" : "",
		"provinsi_id" : "81",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 442,
		"name" : "Maluku Tenggara Barat",
		"code" : "8103",
		"regent_mayor" : "",
		"provinsi_id" : "81",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 443,
		"name" : "Buru",
		"code" : "8104",
		"regent_mayor" : "",
		"provinsi_id" : "81",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 444,
		"name" : "Kepulauan Aru",
		"code" : "8105",
		"regent_mayor" : "",
		"provinsi_id" : "81",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 445,
		"name" : "Seram Bagian Barat",
		"code" : "8106",
		"regent_mayor" : "",
		"provinsi_id" : "81",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 446,
		"name" : "Seram Bagian Timur",
		"code" : "8107",
		"regent_mayor" : "",
		"provinsi_id" : "81",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 447,
		"name" : "Maluku Barat Daya",
		"code" : "8108",
		"regent_mayor" : "",
		"provinsi_id" : "81",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 448,
		"name" : "Buru Selatan",
		"code" : "8109",
		"regent_mayor" : "",
		"provinsi_id" : "81",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 449,
		"name" : "Kota Ambon",
		"code" : "8171",
		"regent_mayor" : "",
		"provinsi_id" : "81",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 450,
		"name" : "Kota Tual",
		"code" : "8172",
		"regent_mayor" : "",
		"provinsi_id" : "81",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 451,
		"name" : "Halmahera Barat",
		"code" : "8201",
		"regent_mayor" : "",
		"provinsi_id" : "82",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 452,
		"name" : "Halmahera Tengah",
		"code" : "8202",
		"regent_mayor" : "",
		"provinsi_id" : "82",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 453,
		"name" : "Halmahera Utara",
		"code" : "8203",
		"regent_mayor" : "",
		"provinsi_id" : "82",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 454,
		"name" : "Halmahera Selatan",
		"code" : "8204",
		"regent_mayor" : "",
		"provinsi_id" : "82",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 455,
		"name" : "Kepulauan Sula",
		"code" : "8205",
		"regent_mayor" : "",
		"provinsi_id" : "82",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 456,
		"name" : "Halmahera Timur",
		"code" : "8206",
		"regent_mayor" : "",
		"provinsi_id" : "82",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 457,
		"name" : "Pulau Morotai",
		"code" : "8207",
		"regent_mayor" : "",
		"provinsi_id" : "82",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 458,
		"name" : "Kota Ternate",
		"code" : "8271",
		"regent_mayor" : "",
		"provinsi_id" : "82",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 459,
		"name" : "Kota Tidore Kepulauan",
		"code" : "8272",
		"regent_mayor" : "",
		"provinsi_id" : "82",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 460,
		"name" : "Merauke",
		"code" : "9101",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 461,
		"name" : "Jayawijaya",
		"code" : "9102",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 462,
		"name" : "Jayapura",
		"code" : "9103",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 463,
		"name" : "Nabire",
		"code" : "9104",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 464,
		"name" : "Kepulauan Yapen",
		"code" : "9105",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 465,
		"name" : "Biak Numfor",
		"code" : "9106",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 466,
		"name" : "Puncak Jaya",
		"code" : "9107",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 467,
		"name" : "Paniai",
		"code" : "9108",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 468,
		"name" : "Mimika",
		"code" : "9109",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 469,
		"name" : "Sarmi",
		"code" : "9110",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 470,
		"name" : "Keerom",
		"code" : "9111",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 471,
		"name" : "Pegunungan Bintang",
		"code" : "9112",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 472,
		"name" : "Yahukimo",
		"code" : "9113",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 473,
		"name" : "Tolikara",
		"code" : "9114",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 474,
		"name" : "Waropen",
		"code" : "9115",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 475,
		"name" : "Boven Digul",
		"code" : "9116",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 476,
		"name" : "Mappi",
		"code" : "9117",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 477,
		"name" : "Asmat",
		"code" : "9118",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 478,
		"name" : "Supiori",
		"code" : "9119",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 479,
		"name" : "Mamberamo Raya",
		"code" : "9120",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 480,
		"name" : "Mamberamo Tengah",
		"code" : "9121",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 481,
		"name" : "Yalimo",
		"code" : "9122",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 482,
		"name" : "Lanny Jaya",
		"code" : "9123",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 483,
		"name" : "Nduga",
		"code" : "9124",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 484,
		"name" : "Puncak",
		"code" : "9125",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 485,
		"name" : "Dogiyai",
		"code" : "9126",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 486,
		"name" : "Intan Jaya",
		"code" : "9127",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 487,
		"name" : "Deiyai",
		"code" : "9128",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 488,
		"name" : "Kota Jayapura",
		"code" : "9171",
		"regent_mayor" : "",
		"provinsi_id" : "91",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 489,
		"name" : "Sorong",
		"code" : "9201",
		"regent_mayor" : "",
		"provinsi_id" : "92",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 490,
		"name" : "Manokwari",
		"code" : "9202",
		"regent_mayor" : "",
		"provinsi_id" : "92",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 491,
		"name" : "Fak Fak",
		"code" : "9203",
		"regent_mayor" : "",
		"provinsi_id" : "92",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 492,
		"name" : "Sorong Selatan",
		"code" : "9204",
		"regent_mayor" : "",
		"provinsi_id" : "92",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 493,
		"name" : "Raja Ampat",
		"code" : "9205",
		"regent_mayor" : "",
		"provinsi_id" : "92",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 494,
		"name" : "Teluk Bintuni",
		"code" : "9206",
		"regent_mayor" : "",
		"provinsi_id" : "92",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 495,
		"name" : "Teluk Wondama",
		"code" : "9207",
		"regent_mayor" : "",
		"provinsi_id" : "92",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 496,
		"name" : "Kaimana",
		"code" : "9208",
		"regent_mayor" : "",
		"provinsi_id" : "92",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 497,
		"name" : "Tambrauw",
		"code" : "9209",
		"regent_mayor" : "",
		"provinsi_id" : "92",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 498,
		"name" : "Maybrat",
		"code" : "9210",
		"regent_mayor" : "",
		"provinsi_id" : "92",
		"is_city" : 0,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	},
	{
		"id" : 499,
		"name" : "Kota Sorong",
		"code" : "9271",
		"regent_mayor" : "",
		"provinsi_id" : "92",
		"is_city" : 1,
		"is_active" : 1,
		"created_at" : null,
		"updated_at" : null
	}
]


export default KabupatenData